import { useEdgeApi } from "./useEdgeApi";

export interface ResolutionReason {
    id: number;
    reason: string;
    type?: string;
    name?: string;
    commentRequired?: boolean;
}

export const useIncidentResolveReasons = () => {
    const edgeApi = useEdgeApi();

    // Fetch resolution reasons for given incident type
    const fetchResolveReasons = async (
        incidentType: string,
    ): Promise<ResolutionReason[]> => {
        const { data } = await edgeApi.get<ResolutionReason[]>(
            "/incident-resolve-reason",
            { params: { incidentType } },
        );
        return data ?? [];
    };

    // Fetch drill resolve reason for given incident type.
    // Find by searching for name that contains "drill" or fallback to first reason.
    const fetchDrillResolveReason = async (
        incidentType: string,
    ): Promise<ResolutionReason> => {
        const reasons = await fetchResolveReasons(incidentType);
        const reason =
            reasons.find((r) => (r.name ?? "").toLowerCase().includes("drill")) ??
            reasons[0];

        if (!reason) {
            throw new Error(
                `No resolution reason available for incident type "${incidentType}"`,
            );
        }
        return reason;
    };

    return { fetchResolveReasons, fetchDrillResolveReason };
};
